import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../symbols';
let SessionManagementService = class SessionManagementService {
    constructor(Api) {
        this.Api = Api;
        this.getAccountsSessions = this.Api.getAccountsSessions;
        this.getCompanySessions = this.Api.getCompanySessions;
        this.deleteKickEmailSessions = this.Api.deleteKickEmailSessions;
    }
};
SessionManagementService = __decorate([
    injectable(),
    __param(0, inject(Symbols.SessionManagementApi)),
    __metadata("design:paramtypes", [Object])
], SessionManagementService);
export { SessionManagementService };
